var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import * as baobab from '@data/baobab/baobab';
import Keycloak from 'keycloak-js';
import { getTestUsers } from '@shared/testUsers/testUsersActions';
import { addMiddleware, requestContext, usersApi } from '@data/rest/api';
import Manager from '@shared/modal/Manager';
import React from 'react';
import Modal from '@shared/modal/Modal';
import { userSettingsSelectFunction } from '@data/hooks/currentUser';
import { decimalSeparatorsByLocale } from '@util/enums';
import numbro from 'numbro';
import { deepClone } from '../util/clone';
function getLastSubdomain(host) {
    return host.split('.')[0].split(':')[0];
}
function localUserChooser(event) {
    var e_1, _a;
    if (!event.ctrlKey || !event.shiftKey || event.key !== 'U') {
        return;
    }
    var testUsers = baobab.root.select('testUsers').get();
    if (!testUsers || testUsers.length === 0) {
        return;
    }
    var testUserComponents = [];
    var _loop_1 = function (testUser) {
        var onClick = function () {
            localStorage[LocalAuthenticationActions.LOCAL_STORAGE_KEY] = testUser.keycloakId;
            window.location.href = '/';
        };
        testUserComponents.push(React.createElement("li", null,
            React.createElement("div", null,
                testUser.email,
                React.createElement("button", { onClick: onClick }, "set"))));
    };
    try {
        for (var testUsers_1 = __values(testUsers), testUsers_1_1 = testUsers_1.next(); !testUsers_1_1.done; testUsers_1_1 = testUsers_1.next()) {
            var testUser = testUsers_1_1.value;
            _loop_1(testUser);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (testUsers_1_1 && !testUsers_1_1.done && (_a = testUsers_1.return)) _a.call(testUsers_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    Manager.renderModal(React.createElement(Modal, { width: 300, closeOnEscape: true }, testUserComponents));
}
export function getUserSettings(queryClient) {
    return __awaiter(this, void 0, void 0, function () {
        var ss, userSettings, locale, s, separator, languageClone;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, usersApi.getSmartSettings()];
                case 1:
                    ss = _a.sent();
                    userSettings = userSettingsSelectFunction(ss);
                    queryClient.setQueryData(['currentUserSettings'], userSettings);
                    decimalSeparatorsByLocale.forEach(function (loc) {
                        var locObj = require("numbro/languages/".concat(loc.locale));
                        var locale = loc.locale, separator = loc.separator;
                        if (locObj) {
                            locObj.delimiters.decimal = separator === 'comma' ? ',' : '.';
                            numbro.registerLanguage(locObj);
                            numbro.setLanguage(locale);
                        }
                    });
                    require('numbro/languages/' + userSettings.user_currency_locale_locale);
                    locale = userSettings.user_currency_locale_locale;
                    s = decimalSeparatorsByLocale.find(function (ds) { return ds.locale === locale; });
                    separator = (s === null || s === void 0 ? void 0 : s.separator) || 'comma';
                    languageClone = numbro.languages()[locale]
                        ? deepClone(numbro.languages()[locale])
                        : deepClone(numbro.languages()[numbro.language()]);
                    if (languageClone) {
                        languageClone.delimiters.decimal = separator === 'comma' ? ',' : '.';
                        numbro.registerLanguage(languageClone);
                        numbro.setLanguage(locale);
                    }
                    return [2 /*return*/, true];
            }
        });
    });
}
var LocalAuthenticationActions = /** @class */ (function () {
    function LocalAuthenticationActions(tenantId) {
        baobab.root.select(['currentUser', 'tenantId']).set(tenantId);
    }
    LocalAuthenticationActions.prototype.signIn = function () {
        return __awaiter(this, void 0, Promise, function () {
            var testUsers, keycloakId_1, selectedUser, jwt, tenantId_1, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getTestUsers()];
                    case 1:
                        testUsers = _a.sent();
                        if (testUsers.length === 0) {
                            console.warn('Fetched 0 test users');
                            return [2 /*return*/];
                        }
                        keycloakId_1 = localStorage[LocalAuthenticationActions.LOCAL_STORAGE_KEY];
                        selectedUser = keycloakId_1
                            ? testUsers.find(function (element) { return element.keycloakId === keycloakId_1; })
                            : undefined;
                        jwt = selectedUser ? selectedUser.jwt : testUsers[0].jwt;
                        tenantId_1 = selectedUser ? selectedUser.tenantId : testUsers[0].tenantId;
                        baobab.root.select('testUsers').set(testUsers);
                        baobab.root.select('currentUser').set('token', jwt);
                        baobab.root.select('currentUser').set('tenantId', tenantId_1);
                        document.addEventListener('keydown', localUserChooser);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.warn('Failed to fetch test users');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LocalAuthenticationActions.prototype.signOut = function () {
        return __awaiter(this, void 0, Promise, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    LocalAuthenticationActions.prototype.requestInitializer = function (request) {
        return __awaiter(this, void 0, Promise, function () {
            var token, tenantId;
            return __generator(this, function (_a) {
                token = baobab.root.select('currentUser').get('token');
                tenantId = baobab.root.select('currentUser').get('tenantId');
                if (token !== undefined) {
                    request.headers.set('Authorization', 'Bearer ' + token);
                    request.headers.set('X-TENANT-ID', tenantId);
                }
                return [2 /*return*/];
            });
        });
    };
    LocalAuthenticationActions.prototype.requestContextInitializer = function (requestContext) {
        return __awaiter(this, void 0, Promise, function () {
            var token, tenantId;
            return __generator(this, function (_a) {
                token = baobab.root.select('currentUser').get('token');
                tenantId = baobab.root.select('currentUser').get('tenantId');
                if (token !== undefined) {
                    requestContext.init.headers['Authorization'] = 'Bearer ' + token;
                    requestContext.init.headers['X-TENANT-ID'] = tenantId;
                }
                return [2 /*return*/, __assign({}, requestContext)];
            });
        });
    };
    LocalAuthenticationActions.LOCAL_STORAGE_KEY = 'selected_local_user';
    return LocalAuthenticationActions;
}());
export { LocalAuthenticationActions };
var MultiTenantKeycloakAuthenticationActions = /** @class */ (function () {
    function MultiTenantKeycloakAuthenticationActions(tenantId) {
        var _this = this;
        this.keycloak = new Keycloak("/api/v3/keycloakConfigurations/default");
        this.keycloak.onTokenExpired = function () { return _this.handleTokenRefresh(); };
        baobab.root.select(['currentUser', 'tenantId']).set(tenantId);
    }
    MultiTenantKeycloakAuthenticationActions.prototype.signIn = function () {
        return __awaiter(this, void 0, Promise, function () {
            var authenticated;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.keycloak.init({
                            onLoad: 'login-required',
                            checkLoginIframe: false,
                            pkceMethod: 'S256',
                            responseMode: 'query', // todo switch back to fragment (default)
                        })];
                    case 1:
                        authenticated = _a.sent();
                        if (authenticated) {
                            baobab.root.select('currentUser').set('token', this.keycloak.token);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MultiTenantKeycloakAuthenticationActions.prototype.signOut = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.internalSignOut()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MultiTenantKeycloakAuthenticationActions.prototype.internalSignOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        //invalidate cookies to prevent login attempt
                        document.cookie.split(';').forEach(function (c) {
                            document.cookie = c
                                .replace(/^ +/, '')
                                .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
                        });
                        return [4 /*yield*/, this.keycloak.logout()];
                    case 1:
                        _a.sent();
                        //@ts-ignore
                        zE('messenger', 'logoutUser');
                        window.location.href = '/';
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        console.warn('Logout failed', err_2);
                        window.location.href = '/';
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MultiTenantKeycloakAuthenticationActions.prototype.requestInitializer = function (request) {
        return __awaiter(this, void 0, Promise, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.handleTokenRefresh()];
                    case 1:
                        _a.sent();
                        token = baobab.root.select('currentUser').get('token');
                        if (token !== undefined) {
                            request.headers.set('Authorization', 'Bearer ' + token);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MultiTenantKeycloakAuthenticationActions.prototype.requestContextInitializer = function (requestContext) {
        return __awaiter(this, void 0, Promise, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.handleTokenRefresh()];
                    case 1:
                        _a.sent();
                        token = baobab.root.select('currentUser').get('token');
                        if (token !== undefined) {
                            requestContext.init.headers['Authorization'] = 'Bearer ' + token;
                        }
                        return [2 /*return*/, __assign({}, requestContext)];
                }
            });
        });
    };
    MultiTenantKeycloakAuthenticationActions.prototype.handleTokenRefresh = function () {
        return __awaiter(this, void 0, Promise, function () {
            var refreshed, exception_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, this.keycloak.updateToken(30)];
                    case 1:
                        refreshed = _a.sent();
                        if (refreshed) {
                            baobab.root.select('currentUser').set('token', this.keycloak.token);
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        exception_1 = _a.sent();
                        return [4 /*yield*/, this.internalSignOut()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return MultiTenantKeycloakAuthenticationActions;
}());
export { MultiTenantKeycloakAuthenticationActions };
var SignInActions;
var EntryLinkAuthenticationActions = /** @class */ (function () {
    function EntryLinkAuthenticationActions(tenantId) {
        var pathSegments = document.location.href.split('/');
        this.entryLinkKey = pathSegments[pathSegments.length - 1];
        baobab.root.select(['currentUser', 'tenantId']).set(tenantId);
    }
    EntryLinkAuthenticationActions.prototype.signIn = function () {
        return __awaiter(this, void 0, Promise, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    EntryLinkAuthenticationActions.prototype.signOut = function () {
        return __awaiter(this, void 0, Promise, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    EntryLinkAuthenticationActions.prototype.requestInitializer = function (request) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                if (this.entryLinkKey) {
                    request.headers.set('X-DATA-ENTRY-LINK', this.entryLinkKey);
                }
                return [2 /*return*/];
            });
        });
    };
    EntryLinkAuthenticationActions.prototype.requestContextInitializer = function (requestContext) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                if (this.entryLinkKey) {
                    requestContext.init.headers['X-DATA-ENTRY-LINK'] = this.entryLinkKey;
                }
                return [2 /*return*/, __assign({}, requestContext)];
            });
        });
    };
    return EntryLinkAuthenticationActions;
}());
var tenantId = process.env.AUTHENTICATION === 'development-keycloak' ? 'farseer-dev' : getLastSubdomain(window.location.host);
if (document.location.href.includes('entrylink')) {
    SignInActions = new EntryLinkAuthenticationActions(tenantId);
}
else if (process.env.AUTHENTICATION === 'local') {
    SignInActions = new LocalAuthenticationActions(tenantId);
}
else {
    SignInActions = new MultiTenantKeycloakAuthenticationActions(tenantId);
}
var requestInitializer = function (request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, SignInActions.requestInitializer(request)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
requestContext.addRequestInitializer(requestInitializer);
var middleware = {
    pre: function (requestContext) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, SignInActions.requestContextInitializer(requestContext)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); },
};
addMiddleware(middleware);
export default SignInActions;
